import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";
import { Card } from "@/components/ui/card";
import { 
  Stethoscope, 
  ClipboardList, 
  LineChart,
  ArrowLeft
} from "lucide-react";
import { Link } from "react-router-dom";

const ClinicalWorkflowDetails = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <main>
        <section className="relative py-24">
          <div className="absolute inset-0 bg-gradient-to-b from-white via-[#F5F5F7] to-white" />
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
            <Link to="/enterprise" className="inline-flex items-center text-primary mb-8 hover:opacity-80">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Enterprise
            </Link>
            <h1 className="text-4xl font-bold text-gray-900 mb-6">
              Clinical Workflow Integration Details
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mb-12">
              Discover how Scienza Health seamlessly integrates into your existing clinical processes while enhancing efficiency and patient care quality.
            </p>

            <div className="grid gap-8 md:grid-cols-1 lg:grid-cols-3">
              <Card className="p-8 hover:shadow-lg transition-shadow duration-300">
                <div className="bg-primary/10 p-4 rounded-lg w-16 h-16 flex items-center justify-center mb-6">
                  <Stethoscope className="w-8 h-8 text-primary" />
                </div>
                <h2 className="text-2xl font-semibold mb-4">Patient Assessment</h2>
                <div className="space-y-4 text-gray-600">
                  <p>Our advanced cognitive assessment tools seamlessly integrate with your existing EHR systems, providing:</p>
                  <ul className="list-disc pl-5 space-y-2">
                    <li>Standardized cognitive assessment protocols</li>
                    <li>Real-time data synchronization with EHR</li>
                    <li>Automated scoring and interpretation</li>
                    <li>Custom assessment templates</li>
                    <li>Multi-language support</li>
                  </ul>
                </div>
              </Card>

              <Card className="p-8 hover:shadow-lg transition-shadow duration-300">
                <div className="bg-primary/10 p-4 rounded-lg w-16 h-16 flex items-center justify-center mb-6">
                  <ClipboardList className="w-8 h-8 text-primary" />
                </div>
                <h2 className="text-2xl font-semibold mb-4">Care Planning</h2>
                <div className="space-y-4 text-gray-600">
                  <p>Leverage AI-powered insights to create personalized care plans:</p>
                  <ul className="list-disc pl-5 space-y-2">
                    <li>Evidence-based treatment recommendations</li>
                    <li>Personalized intervention strategies</li>
                    <li>Medication management support</li>
                    <li>Care team collaboration tools</li>
                    <li>Family engagement features</li>
                  </ul>
                </div>
              </Card>

              <Card className="p-8 hover:shadow-lg transition-shadow duration-300">
                <div className="bg-primary/10 p-4 rounded-lg w-16 h-16 flex items-center justify-center mb-6">
                  <LineChart className="w-8 h-8 text-primary" />
                </div>
                <h2 className="text-2xl font-semibold mb-4">Progress Tracking</h2>
                <div className="space-y-4 text-gray-600">
                  <p>Monitor and analyze patient progress with comprehensive tools:</p>
                  <ul className="list-disc pl-5 space-y-2">
                    <li>Advanced analytics dashboard</li>
                    <li>Customizable progress reports</li>
                    <li>Outcome measurement tools</li>
                    <li>Trend analysis and predictions</li>
                    <li>Quality metrics tracking</li>
                  </ul>
                </div>
              </Card>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default ClinicalWorkflowDetails;